exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recent-order-reorder[data-v-3ec53c9f] {\n  padding: 0 15px;\n}\n.recent-order-summary[data-v-3ec53c9f] {\n  font-size: 14px;\n  color: #666;\n}\n.reorder-all-wrapper[data-v-3ec53c9f] {\n  margin-top: 15px;\n}\n", ""]);

// exports
